import Vue from "vue";
import VueRouter from "vue-router";
/* Rotas de autenticação */
import Auth from "./adm/auth";
/* Rotas de modulos */
import Modules from "./adm/modules";
import Middleware from "./middleware";
import RilReportState from "@/store/report-ril/state.js";
import MilkExtractionReportState from "@/store/milk-extractions-report/state.js";

Vue.use(VueRouter);

const routes = [
  ...Auth,
  ...Modules
];

const router = new VueRouter({
  mode:"history",
  routes
});

router.beforeEach(Middleware);

// Ao sair do RIL/Extrato, limpa o resultado para a próxima consulta não abrir com o anterior.
router.afterEach((_, from) => {
  if(from.path === "/relatorio-ril") {
    RilReportState.results = [];
  }
  else if(from.path === "/relatorio-extracao-leite") {
    MilkExtractionReportState.results = {};
  }
});

export default router;
